import { call, put, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';

export function* create({ payload: { ownerCompanyId, contractorCompanyId, values } }) {
  try {
    const { data } = yield call(
      dataProvider.createOne,
      `companies/${ownerCompanyId}/owner-working-hours/${contractorCompanyId}/answers`,
      values,
    );
    yield put({
      type: currentCompany.contractorWorkingHoursAnswers.create.end,
      payload: { answers: data },
    });
    yield put({ type: notification.add, payload: { success: 'Answers saved successfully' } });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: e.message } });
    yield put({ type: currentCompany.contractorWorkingHoursAnswers.create.error });
  }
}

export default function* createWorkingHoursAnswersSaga() {
  yield takeLatest(currentCompany.contractorWorkingHoursAnswers.create.start, create);
}
